/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    getAll: async () => exeRequest('/admin/marques-vehicule', 'GET'),
    getById: async (id) => exeRequest(`/admin/marques-vehicule/${id}`, 'GET'),
    create: async (data) => exeRequest('/admin/marques-vehicule', 'POST', data),
    update: async (id, data) => exeRequest(`/admin/marques-vehicule/${id}`, 'PUT', data),
    delete: async (id) => exeRequest(`/admin/marques-vehicule/${id}`, 'DELETE'),
    addModele: async (id, data) => exeRequest(`/admin/marques-vehicule/${id}/modeles`, 'POST', data),
    removeModele: async (id, modele) => exeRequest(`/admin/marques-vehicule/${id}/modeles/${encodeURIComponent(modele)}`, 'DELETE'),
    seed: async (force = false) => exeRequest(`/admin/marques-vehicule/seed${force ? '?force=true' : ''}`, 'POST'),
};
